"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var mobx_react_1 = require("mobx-react");
var Error_1 = require("./Error");
var Spinner_1 = require("office-ui-fabric-react/lib/Spinner");
var Sync_styles_1 = require("./Sync.styles");
var Sync_classNames_1 = require("./Sync.classNames");
var defaultOnRenderDone = function (props) {
    return null;
};
var defaultOnRenderSync = function (props) {
    return React.createElement(Spinner_1.Spinner, { className: "sync-spinner", label: props.syncLabel || "Loading..." });
};
var defaultOnRenderError = function (error) {
    return React.createElement(Error_1.Error, { className: "sync-error-message", error: error });
};
var DefaultSyncProps = {
    sync: null,
    onRenderDone: defaultOnRenderDone,
    onRenderSync: defaultOnRenderSync,
    onRenderError: defaultOnRenderError
};
exports.DefaultSyncProps = DefaultSyncProps;
var Sync = /** @class */ (function (_super) {
    __extends(Sync, _super);
    function Sync() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Sync.prototype._renderSyncError = function () {
        var error = this.props.sync.error;
        return this.props.onRenderError ?
            this.props.onRenderError(error, this.props) :
            DefaultSyncProps.onRenderError(error, this.props);
    };
    Sync.prototype._renderSyncing = function () {
        var syncContent = this.props.onRenderSync ?
            this.props.onRenderSync(this.props) :
            DefaultSyncProps.onRenderSync(this.props);
        return (React.createElement("div", { className: this._classNames.root }, syncContent));
    };
    Sync.prototype.render = function () {
        this._classNames = Sync_classNames_1.getClassNames(Sync_styles_1.getStyles(null, this.props.styles), this.props.className);
        var content;
        var sync = this.props.sync;
        if (sync.syncing) {
            content = this._renderSyncing();
        }
        else if (sync.error) {
            content = this._renderSyncError();
        }
        else if (sync.hasSynced) {
            content = this.props.onRenderDone(this.props);
        }
        else {
            content = this.props.onRenderDefault ? this.props.onRenderDefault(this.props) : null;
        }
        return content;
    };
    Sync = __decorate([
        mobx_react_1.observer
    ], Sync);
    return Sync;
}(React.Component));
exports.Sync = Sync;
